import { render } from "./LoadElementsPanel.vue?vue&type=template&id=15513b1c&scoped=true"
import script from "./LoadElementsPanel.vue?vue&type=script&lang=ts"
export * from "./LoadElementsPanel.vue?vue&type=script&lang=ts"

import "./LoadElementsPanel.vue?vue&type=style&index=0&id=15513b1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15513b1c"

export default script